module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/brag/brag-01-bb9c44a321f9a72c11beef8430282cef.jpg";